
import {
  TRACKING_SERVICE_OCTLINK,
  OPERATION_OFFICE_DEFAULT_FULL_COLOR_SETTING,
  CSV_DATE_FORMAT,
  SENSOR_ALERT_BATTERY_LEVEL,
  OPERATION_OFFICE_FORM_END_OF_MONTH_DATE_LIST,
  COOPERATION_LIST,
  IS_DISPLAY_ALLOCATED,
} from '@/services/consts/operation_office';
import SelfOfficeType from "@/types/SelfOffice";
import DepartmentType from "@/types/Department";
import Api from "@/services/api/ApiServiceFabrick";

export function initialOperationOffice() {
  
  return {
    external_urls: [{ name: '', url: '' }],
    tracking_service: TRACKING_SERVICE_OCTLINK,
    accounting: {
      cutoff_date: '0',
      payment_site: '0',
      payment_day: '0',
    },
    weekly_aggregation: 'Sun',
    view_threshold: '0',
    is_active_ittenko: false,
    tenko_type: "",
    is_ai_forecast_safe_driving: false,
    enable_set_start_and_end_of_working_time: '0',
    view_1day_unit: '0',
    imprinter_name: ['', '', ''],
    settings_monthly_report: {
      color_setting_monthly: "0",
      color_setting: OPERATION_OFFICE_DEFAULT_FULL_COLOR_SETTING,
      bound_time_by_days: null,
      bound_time_by_hours: null,
      over_time_thresholds_type: "0",
      over_time_thresholds: {
        daily: { hours: "", minutes: "" },
        monthly: {
          1: { hours: "", minutes: "" },
          2: { hours: "", minutes: "" },
          3: { hours: "", minutes: "" },
          4: { hours: "", minutes: "" },
          5: { hours: "", minutes: "" },
          6: { hours: "", minutes: "" },
          7: { hours: "", minutes: "" },
          8: { hours: "", minutes: "" },
          9: { hours: "", minutes: "" },
          10: { hours: "", minutes: "" },
          11: { hours: "", minutes: "" },
          12: { hours: "", minutes: "" },
        }
      },
      over_time_working_hour_thresholds: {},
      csv_date_format: CSV_DATE_FORMAT[0],
      report_deadline_day: OPERATION_OFFICE_FORM_END_OF_MONTH_DATE_LIST[2],
      cooperation: COOPERATION_LIST[0]
    },
    tdsensor: false,
    sensor_notification_battery_level: SENSOR_ALERT_BATTERY_LEVEL[0],
    is_display_allocated_content: false,
    allocated_minute: null,
    allocated_work: '',
    is_display_allocated: IS_DISPLAY_ALLOCATED[0].value,
  }
}

function isDepartmentType(data: SelfOfficeType | DepartmentType): data is DepartmentType {
  return 'operation_office' in data
}

export async function getSelfOffice() {
  const data: SelfOfficeType | DepartmentType = await Api().getSelfOffice()
  if (isDepartmentType(data)) {
    // 組織ユーザーの場合
    return data.operation_office
  }
  return data
}
